// Utils
import debounce from 'lodash/debounce';
import { component } from 'picoapp';
import Swiper, { A11y, Manipulation, Mousewheel, Scrollbar } from 'swiper';

import choozy from 'utils/choozy';

Swiper.use([A11y, Manipulation, Mousewheel, Scrollbar]);

export default component((node) => {
  const { scrollbar, goBackButton } = choozy(node);

  const initSwiper = (
    _event,
    { isMobile } = window.theme,
    isLowScreen = window.innerHeight < 600,
  ) => {
    if (isMobile && isLowScreen) {
      node.swiper?.destroy();
    } else if (!node.swiper) {
      new Swiper(node, {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        mousewheel: true,
        scrollbar: {
          el: scrollbar,
          draggable: false,
        },
        on: {
          touchMoveOpposite: debounce((swiper) => {
            const { startY, currentY } = swiper.touches;

            if (startY < currentY) {
              swiper.slidePrev();
            } else {
              swiper.slideNext();
            }
          }, 100),
        },
      });
    }
  };

  const slideTo = (event) => {
    const { target } = event;
    const section = target.closest('.shopify-section');
    const index = [...section.parentNode.children].indexOf(section);

    node.swiper?.slideTo(index, 100);
  };

  initSwiper();

  goBackButton.addEventListener('click', () => {
    if (document.referrer.includes('/blogs/')) {
      window.history.back();
    } else {
      window.location = goBackButton.dataset.blogUrl;
    }
  });
  document.addEventListener('theme:screen:size-updated', initSwiper);

  if (window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSwiper);
    document.addEventListener('shopify:section:select', slideTo);
  }
});
